<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    class="scan-upc-batch-dialog"
    :close-on-click-modal="false"
    @open="onOpen"
    @closed="onClosed"
  >
    <div v-if="document" class="scan-header">


    <mdb-row >
        <mdb-col col="6">
            <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer" vid="docNum" name="docNum" v-model="document.CardName" size="sm" :disabled="true"/>
            <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Invoice" vid="docNum" name="docNum" v-model="document.NumAtCard" size="sm" :disabled="true"/>
           </mdb-col>
       
    </mdb-row>

        
    </div>
    <div style="margin-bottom: 12px;">
      <el-input
        ref="scanInput"
        v-model="scanText"
        placeholder="Scan"
        clearable
        @input="tryAutoAdd"
        @keyup.enter.native="handleScan"
        @blur="onScanBlur"
      >
        <template slot="append">
          <el-button type="primary" @click="handleScan">Add</el-button>
        </template>
      </el-input>
      
    </div>

    <el-table
      :data="rows"
      border
      height="360"
      row-key="id"
      empty-text="No scanned items yet."
    >
      <el-table-column label="UPC" prop="upc" min-width="170" />
      <el-table-column label="Item Code" prop="itemCode" min-width="170" />
      <el-table-column label="Description" prop="description" min-width="260" show-overflow-tooltip />

      <el-table-column label="Warehouse" min-width="140">
        <template slot-scope="scope">
          <div>
            <div><b>{{ scope.row.whsCode }}</b></div>
            <div style="font-size: 12px; color: #909399;">
              {{ scope.row.whsName || "-" }}
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Batch Number" prop="batch" min-width="150" />

      <el-table-column label="OnHand" min-width="110" align="right">
        <template slot-scope="scope">
          {{ scope.row.onHand != null ? scope.row.onHand : "-" }}
        </template>
      </el-table-column>

      <el-table-column label="Qty" min-width="140">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.qty"
            :min="1"
            :step="1"
            controls-position="right"
            style="width: 120px;"
            @focus="isEditingQty = true"
            @blur="onQtyBlur"
          />
        </template>
      </el-table-column>

      <el-table-column label="Action" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="removeRow(scope.$index)">
            Remove
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <mdb-btn color="grey" size="sm" @click="dialogVisible = false">Cancel</mdb-btn>
      <mdb-btn color="elegant" size="sm" :disabled="rows.length === 0" @click="submit">Scan Collected Items</mdb-btn>
    </span>
  </el-dialog>
</template>

<script>
import { ThatsInput } from '../../components/thats/Thats'
import {mdbBtn, mdbRow,mdbCol} from "mdbvue";
const PREFIX = "]d201";
const MID_DELIM = "10";
const FULL_SCAN_REGEX = /^\]d201\d+10\d{4}-\d{2}-\d{2}$/;

export default {
  name: "ScanUpcBatchDialog",
    components : {
        mdbBtn, mdbRow,mdbCol, ThatsInput
    },
  props: {
    value: { type: Boolean, default: false }, // v-model
    title: { type: String, default: "Scan UPC / Batch" },

    // Document object containing DocumentLines as shown in your example
    document: { type: Object, required: true },

    // Optional: if the same batch exists in multiple warehouses, prefer this WhsCode
    preferWhsCode: { type: String, default: "" }
  },

  data() {
    return {
      scanText: "",
      rows: [],
      isEditingQty: false
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },

    documentLines() {
      const lines = this.document && this.document.DocumentLines;
      return Array.isArray(lines) ? lines : [];
    }
  },

  methods: {
    // ----------------------------
    // Notifications (your notifier)
    // ----------------------------
    notifySuccess(message) {
      if (this.$ThatsNotify && this.$ThatsNotify.success) {
        this.$ThatsNotify.success({ message });
        return;
      }
      // Optional fallback (safe if plugin not mounted)
      if (this.$message && this.$message.success) this.$message.success(message);
    },

    notifyWarning(message) {
      if (this.$ThatsNotify && this.$ThatsNotify.warning) {
        this.$ThatsNotify.warning({ message });
        return;
      }
      if (this.$message && this.$message.warning) this.$message.warning(message);
    },

    notifyError(message, timeOut = 20000) {
      if (this.$ThatsNotify && this.$ThatsNotify.error) {
        this.$ThatsNotify.error({ message, timeOut });
        return;
      }
      if (this.$message && this.$message.error) this.$message.error(message);
    },

    // ----------------------------
    // Focus management
    // ----------------------------
    focusScanInput() {
      this.$nextTick(() => {
        const ref = this.$refs.scanInput;
        if (!ref) return;

        if (typeof ref.focus === "function") {
          ref.focus();
          return;
        }

        const native = ref.$el && ref.$el.querySelector("input");
        if (native) native.focus();
      });
    },

    onOpen() {
      this.focusScanInput();
    },

    onClosed() {
      this.scanText = "";
      this.rows = [];
      this.isEditingQty = false;
    },

    onScanBlur() {
      setTimeout(() => {
        if (!this.dialogVisible) return;
        if (this.isEditingQty) return;
        this.focusScanInput();
      }, 0);
    },

    onQtyBlur() {
      this.isEditingQty = false;
      this.focusScanInput();
    },

    // ----------------------------
    // Parsing logic
    // ----------------------------
    parseScan(raw) {
      const code = String(raw || "").trim();
      if (!code.startsWith(PREFIX)) return null;

      const rest = code.slice(PREFIX.length);

      const batchMatch = rest.match(/(\d{4}-\d{2}-\d{2})$/);
      if (!batchMatch) return null;

      const batch = batchMatch[1];
      const beforeBatch = rest.slice(0, rest.length - batch.length);

      if (!beforeBatch.endsWith(MID_DELIM)) return null;

      const upc = beforeBatch.slice(0, -MID_DELIM.length);

      if (!/^\d+$/.test(upc)) return null;
      if (!upc.length) return null;

      return { upc, batch };
    },

    // ----------------------------
    // Document matching
    // ----------------------------
    resolveScanToDocument(upc, batch) {
      const prefer = (this.preferWhsCode || "").trim();
      const candidates = [];

      for (const line of this.documentLines) {
        const codeBars = String(line && line.CodeBars != null ? line.CodeBars : "").trim();
        if (!codeBars || codeBars !== upc) continue;

        // 1) DocumentLines.BatchNumbers
        if (Array.isArray(line.BatchNumbers)) {
          for (const bn of line.BatchNumbers) {
            const bnNo = String(bn && bn.BatchNumber != null ? bn.BatchNumber : "").trim();
            if (bnNo !== batch) continue;

            const whsCode = String((bn && bn.WhsCode) || line.WhsCode || "").trim();

            candidates.push({
              line,
              batchInfo: bn,
              whsCode,
              whsPrefix: (bn && bn.WhsPrefix) || line.WhsPrefix || "",
              source: "DocumentLines.BatchNumbers"
            });
          }
        }

        // 2) DocumentLines.WarehouseStocks[*].BatchNumbers
        if (Array.isArray(line.WarehouseStocks)) {
          for (const ws of line.WarehouseStocks) {
            const wsWhs = String((ws && ws.WhsCode) || "").trim();

            if (Array.isArray(ws.BatchNumbers)) {
              for (const bn of ws.BatchNumbers) {
                const bnNo = String(bn && bn.BatchNumber != null ? bn.BatchNumber : "").trim();
                if (bnNo !== batch) continue;

                const whsCode = String((bn && bn.WhsCode) || wsWhs || "").trim();

                candidates.push({
                  line,
                  batchInfo: bn,
                  whsCode,
                  whsPrefix: (bn && bn.WhsPrefix) || ws.WhsPrefix || "",
                  source: "DocumentLines.WarehouseStocks.BatchNumbers"
                });
              }
            }
          }
        }
      }

      if (candidates.length === 0) return null;

      if (prefer) {
        const preferred = candidates.find(c => String(c.whsCode).trim() === prefer);
        if (preferred) return preferred;
      }

      return candidates[0];
    },

    // ----------------------------
    // Auto-add behavior
    // ----------------------------
    tryAutoAdd(val) {
      const text = String(val || "").trim();
      if (!text) return;

      if (/\s/.test(text)) {
        this.handleScan();
        return;
      }

      if (FULL_SCAN_REGEX.test(text)) {
        this.handleScan();
      }
    },

    // ----------------------------
    // Table operations
    // ----------------------------
    handleScan() {
        const input = (this.scanText || "").trim();
        if (!input) return;

        const tokens = input.split(/\s+/).filter(Boolean);
        let added = 0;

        // NEW: if a scan is valid but not found, clear input after processing
        let shouldClearInput = false;

        try {
            tokens.forEach((t) => {
            const parsed = this.parseScan(t);
            if (!parsed) {
                this.notifyWarning(
                `Invalid scan: "${t}". Expected ]d201<UPC>10<YYYY-MM-DD>.`
                );
                return;
            }

            const { upc, batch } = parsed;

            const resolved = this.resolveScanToDocument(upc, batch);
            if (!resolved) {
                this.notifyWarning(
                `Not found in document lines: UPC "${upc}" with Batch "${batch}".`
                );

                // NEW: clear input once not found (prevents next scan from appending)
                shouldClearInput = true;
                return;
            }

            const { line, batchInfo, whsCode, whsPrefix, source } = resolved;

            const docEntry =
                this.document && this.document.DocEntry != null ? this.document.DocEntry : "";
            const lineNum = line && line.LineNum != null ? line.LineNum : "";
            const id = `${docEntry}|${lineNum}|${upc}|${batch}|${whsCode}`;

            const existing = this.rows.find((r) => r.id === id);
            if (existing) {
                existing.qty += 1;
            } else {
                const whsName =
                String(line.WhsCode || "").trim() === String(whsCode || "").trim()
                    ? (line.WhsName || "")
                    : "";

                const onHandRaw = batchInfo && batchInfo.OnHand != null ? batchInfo.OnHand : null;
                const onHand = onHandRaw != null && onHandRaw !== "" ? Number(onHandRaw) : null;

                this.rows.push({
                id,
                upc,
                batch,
                qty: 1,

                docEntry,
                docNum: this.document && this.document.DocNum,
                lineNum,
                itemCode: line.ItemCode,
                description: line.Dscription,

                whsCode,
                whsName,
                whsPrefix,
                expDate: batchInfo && batchInfo.ExpDate,
                onHand,

                source
                });
            }

            added += 1;
            });
        } catch (e) {
            this.notifyError(
            e && e.message ? e.message : "Unexpected error while processing scan.",
            20000
            );
            // also clear to avoid stuck invalid input
            shouldClearInput = true;
        }

        // CHANGED: clear input if added OR not-found happened
        if (added > 0 || shouldClearInput) {
            this.scanText = "";
            this.focusScanInput();
        }
        },


    removeRow(index) {
      this.rows.splice(index, 1);
      this.focusScanInput();
    },

    submit() {
      const payload = this.rows.map((r) => ({
        docEntry: r.docEntry,
        docNum: r.docNum,
        lineNum: r.lineNum,
        itemCode: r.itemCode,
        upc: r.upc,
        whsCode: r.whsCode,
        batchNumber: r.batch,
        qty: r.qty
      }));

      this.$emit("submit", payload);
      this.dialogVisible = false;
    },

    safe(v) {
      if (v === null || v === undefined || v === "") return "-";
      return String(v);
    },

    isoToYmd(v) {
      const s = String(v || "").trim();
      if (!s) return "-";
      // ISO: YYYY-MM-DDTHH:mm:ss -> YYYY-MM-DD
      if (s.includes("T")) return s.split("T")[0];
      return s;
    },

  }
};
</script>

<style scoped>
.dialog-footer {
  display: inline-flex;
  gap: 8px;
}

code {
  background: #f2f2f2;
  padding: 2px 6px;
  border-radius: 4px;
}
</style>
